import { strapiRepository } from "src/strapi/strapiRepository";
import { ContactBox } from "src/components/homepage/contacts/ContactBox";
import { cn } from "src/lib/utils";
import { Fragment } from "react";

import { createFileRoute } from "@tanstack/react-router";
import { contactsQueryOptions } from "src/react-query/react-query";
import { seo } from "src/utils/seo";

export const Route = createFileRoute("/_breadcrumbs/kontakty")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const contacts = await context.queryClient.ensureQueryData(
      contactsQueryOptions(),
    );

    return {
      crumb: "Kontakty",
      contacts,
    };
  },
  head: () => {
    return {
      meta: [
        ...seo({
          title: "Kontakty | VESAS",
        }),
      ],
    };
  },
});

const Property = ({ label, value }: { label: string; value: string }) => (
  <div>
    {label && <span>{label}:</span>}{" "}
    <span className={"font-semibold"}>{value}</span>
  </div>
);

function RouteComponent() {
  const { contacts } = Route.useLoaderData();

  const { getImageUrl } = strapiRepository;

  if (!contacts) {
    return <div>Žádné kontakty nebyly nalezeny</div>;
  }

  return (
    <div className={"flex flex-col gap-4"}>
      {contacts.company_info && (
        <div className={"grid w-full grid-cols-1 gap-4 md:grid-cols-2"}>
          {contacts.company_info.photo && (
            <img
              src={getImageUrl(contacts.company_info.photo)}
              alt={"Sídlo firmy"}
              className={
                "order-2 max-h-[380px] w-full basis-1 object-cover object-top sm:order-1 sm:basis-1/2"
              }
            />
          )}
          <div className={"order-1 basis-1 sm:order-2 sm:basis-1/2 sm:pl-6"}>
            {contacts.company_info.company_name && (
              <h1 className={"border-b pb-2 text-5xl font-bold"}>
                <Property
                  label={""}
                  value={contacts.company_info.company_name}
                />
              </h1>
            )}

            <address className={"my-2"}>
              {contacts.company_info.address1 && (
                <Property label={""} value={contacts.company_info.address1} />
              )}
              {contacts.company_info.address2 && (
                <Property label={""} value={contacts.company_info.address2} />
              )}
            </address>

            {contacts.company_info.ic && (
              <Property label={"IČO"} value={contacts.company_info.ic} />
            )}

            {contacts.company_info.dic && (
              <Property label={"DIČ"} value={contacts.company_info.dic} />
            )}

            {contacts.company_info.databox && (
              <Property
                label={"Datová schránka"}
                value={contacts.company_info.databox}
              />
            )}

            {contacts.company_info.bank_account_number && (
              <Property
                label={"Bankovní účet"}
                value={contacts.company_info.bank_account_number}
              />
            )}

            {contacts.company_info.email && (
              <Property label={"Email"} value={contacts.company_info.email} />
            )}

            {contacts.company_info.phone && (
              <Property label={"Telefon"} value={contacts.company_info.phone} />
            )}
          </div>
        </div>
      )}
      {contacts.sections.map((section, index) => (
        <Fragment key={section.id}>
          <h1 className={"my-3 text-start text-4xl font-extrabold"}>
            {section.title}
          </h1>
          <div
            className={cn(
              "grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-4",
              {
                "md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2": index === 0,
              },
            )}
          >
            {section.employees?.map((employee) => (
              <ContactBox
                fontSize={index === 0 ? "big" : "small"}
                contact={employee}
                key={employee.id}
              />
            ))}
          </div>
        </Fragment>
      ))}
    </div>
  );
}
